var isAdminOverview;

var AddressListModel = function (addresses) {
    var self = this;

    self.SaveUrl = ajaxUrls.account.EditAddress;
    self.DeleteUrl = ajaxUrls.account.DeleteAddress;

    self.Salutations = ko.observableArray([]);
    self.Countries = ko.observableArray([]);
    self.CommissionReceivers = ko.observableArray([]);
    self.CommissionReceiversArray = ko.observableArray([]);
    self.DefaultCountryId = ko.observable();
    self.DefaultCountryISO = ko.observable();
    self.TermsOfPayments = ko.observableArray([]);
    
    self.Addresses = ko.observableArray([]);
    self.AddressToEdit = ko.observable();
    self.AddressInEditProgress = ko.observable();
    self.AddressToDelete = ko.observable();

    self.IsPrivateCustomer = ko.observable(false);
    self.ShowDeleteButton = ko.observable(false);

    self.isSubmitting = ko.observable(false);

    self.AddressFilterKey = ko.observable('');
    self.CreditDataToEdit = ko.observable();
    self.SaveChangeErrors = ko.observableArray([]);

    self.PopulateAddresses = function(addressListModel) {
        self.ShowDeleteButton(addressListModel.ShowDeleteButton);
        self.PopulateSalutations(addressListModel.Salutations);
        self.PopulateCountries(addressListModel.Countries, addressListModel.DefaultCountry);
        self.PopulateCommissionReceivers(addressListModel.CommissionReceivers);
        self.PopulateTermsOfPayments(addressListModel.TermsOfPayments);
        self.IsPrivateCustomer(addressListModel.IsPrivateCustomer);
        self.Addresses.removeAll();
        if (addressListModel.Addresses) {
            $.each(addressListModel.Addresses, function (index, item) {
                var address = new AddressModel(self);
                address.PopulateAddressModel(item);

                self.attachAddressSubscribers(address);

                self.Addresses.push(address);
            });
        }
    };
    self.PopulateSalutations = function (salutations) {
        self.Salutations([]);

        $.each(salutations, function (i, salutation) {
            var salutationModel = new AddressSalutationModel(self);
            salutationModel.PopulateSalutationModel(salutation);

            self.Salutations.push(salutationModel);
        });
    };
    self.PopulateCountries = function (countries, defaultCountry) {
        self.Countries([]);

        $.each(countries, function (i, country) {
            var countryModel = new AddressCountryModel(self);
            countryModel.PopulateCountryModel(country);
            self.Countries.push(countryModel);
        });

        if (defaultCountry !== undefined && defaultCountry.CountryId !== undefined && defaultCountry.ISO !== undefined) {
            self.DefaultCountryId(defaultCountry.CountryId);
            self.DefaultCountryISO(defaultCountry.ISO);
        }
    };
    
    self.PopulateTermsOfPayments = function (termsOfPayments) {
        self.TermsOfPayments([])
        $.each(termsOfPayments, function (i, termsOfPayment) {
           const termsOfPaymentModel =  new TermsOfPaymentModel(self);
           termsOfPaymentModel.PopulateTermsOfPaymentModel(termsOfPayment);
           self.TermsOfPayments.push(termsOfPaymentModel);
        });
    }

    self.PopulateCommissionReceivers = function (commissionReceivers) {
        if (commissionReceivers != undefined) {
            self.CommissionReceiversArray = commissionReceivers;
            self.CommissionReceivers([]);

            $.each(commissionReceivers,
                function(i, commissionReceiver) {
                    if (commissionReceiver.CommissionReceiverId > 0) {
                        var commissionReceiverModel = new AddressCommissionReceiverModel(self);
                        commissionReceiverModel.PopulateCommissionReceiverModel(commissionReceiver);

                        self.CommissionReceivers.push(commissionReceiverModel);
                    }
                });
        }
    };

    self.DeleteDeliveryAddresses = function () {
        var token = $('input[name="__RequestVerificationToken"]').val();

        $.post(ajaxUrls.account.DeleteDeliveryAddresses, { __RequestVerificationToken: token }, function (lastingAddressId) {
            self.Addresses.remove(function (item) { return item.AddressId() != lastingAddressId; });

            self.RefreshFilteredAddresses();
        }).fail(function () {
                alerts.error();
            });
    };

    self.EditCreditData = function (address) {
        var creditData = new AddressCreditDataModel();
        creditData.GetBankAccountByAddressId(address.AddressId());

        self.CreditDataToEdit(creditData);
        self.OpenEditWindow("#EditCreditData");
    };

    self.SelectAddress = function (address) {
        self.AddressInEditProgress(address);

        var addressToEdit = new AddressModel();
        
        addressToEdit.AddressId(address.AddressId());
        addressToEdit.FirstName(address.FirstName());
        addressToEdit.LastName(address.LastName());
        addressToEdit.City(address.City());
        addressToEdit.Company(address.Company());
        addressToEdit.Country(address.Country());
        addressToEdit.StateProvinceCode(address.StateProvinceCode());
        addressToEdit.CountryId(address.CountryId());
        addressToEdit.PhoneNumber(address.PhoneNumber());
        addressToEdit.Salutation(address.Salutation());
        addressToEdit.SalutationId(address.SalutationId());
        addressToEdit.Street(address.Street());
        addressToEdit.ZipCode(address.ZipCode());
        addressToEdit.DebitorNumber(address.DebitorNumber());
        addressToEdit.CMwSt(address.CMwSt());
        addressToEdit.SalutationId(address.SalutationId());
        addressToEdit.VatId(address.VatId());
        addressToEdit.Skonto(address.Skonto());
        addressToEdit.Email(address.Email());
        addressToEdit.IsPrivateCustomerAddress(address.IsPrivateCustomerAddress());
        addressToEdit.ShowVat(address.ShowVat());
        addressToEdit.IsStateProvinceCodeRequired(address.IsStateProvinceCodeRequired());
        addressToEdit.CommissionReceiver(address.CommissionReceiver());
        addressToEdit.CommissionReceiverId(address.CommissionReceiverId());

        self.attachAddressSubscribers(addressToEdit);

        self.AddressToEdit(addressToEdit);
        self.SaveChangeErrors([]);

        $('#EditAddress').removeClass("was-validated");
        self.OpenEditWindow("#EditNewAddress");
        ApplyToolTip();
    };

    self.DeleteAddress = function (address) {
        self.AddressToDelete(address);
        self.OpenEditWindow("#DeleteConfirmationWindow", "550px");
    };

    self.AddNewAddress = function (address) {
        var newAddress = new AddressModel();
        newAddress.CountryId(self.DefaultCountryId());
        newAddress.IsPrivateCustomerAddress(self.IsPrivateCustomer());
        self.attachAddressSubscribers(newAddress);
        self.AddressToEdit(newAddress);
        self.SaveChangeErrors([]);

        $('#EditAddress').removeClass("was-validated");
        self.OpenEditWindow("#EditNewAddress");        
        ApplyToolTip();
    };
    
    function CloseEditWindow() {
        var Modal = shop.ts.modal.GetModalFromExisting();
        var modal = new Modal("#DeleteConfirmationWindow");
        modal.close();
    }
    
    function ApplyToolTip(){
        if(userSettings.isProductOverviewBs4Enabled) {
            // only required for bs4 layout
            $(function () {
                $('[data-toggle="tooltip"]').tooltip();
            });
            $("#EditNewAddress").removeClass('was-validated');
        }
    }
    

    self.YesDelete = function () {
        $.get(self.DeleteUrl, { id: self.AddressToDelete().AddressId }, function () {
            self.Addresses.remove(self.AddressToDelete());
            self.RefreshFilteredAddresses();
        });

        CloseEditWindow();
    };
    
    self.NoDelete = function () {
        CloseEditWindow();
    };
    

    self.fadeOutAddress = function (elem) {
        if (elem.nodeType === 1) {
            $(elem).fadeOut(function () { $(elem).remove(); });
        }
    };

    self.SaveChanges = function () {
        self.isSubmitting(true);
        self.SaveChangeErrors([]);
        self.AddressToEdit().CommissionReceiver($('#SelectedOption').val());
        var json = ko.toJS(self.AddressToEdit);
        
        // validate address or if admin overview is shown no validation is required use
        if (isAdminOverview || self.AddressToEdit().validate()) {
            $.post(self.SaveUrl, json, function (result) {
                if (result.Success) {
                    if (result.AddressId) {
                        // Insert model
                        self.AddressToEdit().AddressId(result.AddressId);
                        self.Addresses.unshift(self.AddressToEdit());
                        self.RefreshFilteredAddresses();
                    } else {
                        // Update model
                        for (var i = 0; i < self.Addresses().length; i++) {
                            if (self.Addresses()[i].AddressId() == self.AddressToEdit().AddressId()) {

                                self.Addresses()[i].FirstName(self.AddressToEdit().FirstName());
                                self.Addresses()[i].LastName(self.AddressToEdit().LastName());
                                self.Addresses()[i].City(self.AddressToEdit().City());
                                self.Addresses()[i].Company(self.AddressToEdit().Company());
                                self.Addresses()[i].Country(self.AddressToEdit().Country());
                                self.Addresses()[i].StateProvinceCode(self.AddressToEdit().StateProvinceCode());
                                self.Addresses()[i].CountryId(self.AddressToEdit().CountryId());
                                self.Addresses()[i].PhoneNumber(self.AddressToEdit().PhoneNumber());
                                self.Addresses()[i].Salutation(self.AddressToEdit().Salutation());
                                self.Addresses()[i].SalutationId(self.AddressToEdit().SalutationId());
                                self.Addresses()[i].Street(self.AddressToEdit().Street());
                                self.Addresses()[i].ZipCode(self.AddressToEdit().ZipCode());
                                self.Addresses()[i].DebitorNumber(self.AddressToEdit().DebitorNumber());
                                self.Addresses()[i].CMwSt(self.AddressToEdit().CMwSt());
                                self.Addresses()[i].Email(self.AddressToEdit().Email());
                                self.Addresses()[i].VatId(self.AddressToEdit().VatId());
                                self.Addresses()[i].CommissionReceiver(self.AddressToEdit().CommissionReceiver());
                                self.Addresses()[i].CommissionReceiverId(self.AddressToEdit().CommissionReceiverId());
                                self.RefreshFilteredAddresses();
                            }
                        }
                    }
                    CloseEditWindow();
                } else {
                    self.SaveChangeErrors(result.Errors);
                    self.isSubmitting(false);
                }
            });
        }
    };

    self.SaveCreditDataChanges = function () {
        $("#BankAccountIndicator")
            .removeClass("ValidIcon")
            .removeClass("ErrorIcon")
            .addClass("Loading");

        $("#BankAccountIndicator").show();
        $("#BankAccountIndicator").css('display', 'inline-block');

        self.CreditDataToEdit().SaveBankAccount(function () {
            $("#BankAccountIndicator").removeClass("Loading").addClass("ValidIcon");
            $("#BankAccountIndicator").css('display', 'inline-block');
        }, function() {
            $("#BankAccountIndicator").removeClass("Loading").addClass("ErrorIcon");
            $("#BankAccountIndicator").css('display', 'inline-block');
        });
    };

    self.OpenEditWindow = function (id, width) {
        width = typeof width  === 'undefined' ? "900px" : width;
        var title;
        var popoverHeading = $(id).children(".popover-heading");
        if (popoverHeading.length === 1) {
            title = popoverHeading.html();
        }
        var Modal = shop.ts.modal.GetModal();
        var modal = new Modal(id, {
            width: width,
            title: title
        });
        modal.open();
    };

    self.RefreshFilteredAddresses = function (forcedSearchKey) {
        if (forcedSearchKey) {
            self.AddressFilterKey(forcedSearchKey);
        }
        else {
            var bak = self.AddressFilterKey();
            self.AddressFilterKey(-1); //force refiltering
            self.AddressFilterKey(bak);
        }
        location.reload();
    };

    self.FilteredAddresses = ko.computed(function () {
        if (self.AddressFilterKey().length > 0) {
            var results = self.Addresses().filter(function(address) {
                var searchTermLowerCase = self.AddressFilterKey().toLowerCase();
                return (address.Company().toLowerCase().indexOf(searchTermLowerCase) > -1) ||
                    (address.FirstName().toLowerCase().indexOf(searchTermLowerCase) > -1) ||
                    (address.LastName().toLowerCase().indexOf(searchTermLowerCase) > -1) ||
                    (address.Street().toLowerCase().indexOf(searchTermLowerCase) > -1) ||
                    (address.City().toLowerCase().indexOf(searchTermLowerCase) > -1) ||
                    (address.ZipCode().toLowerCase().indexOf(searchTermLowerCase) > -1) ||
                    (address.PhoneNumber().toLowerCase().indexOf(searchTermLowerCase) > -1) ||
                    (address.Country().toLowerCase().indexOf(searchTermLowerCase) > -1) ||
                    (String(address.DebitorNumber()) === searchTermLowerCase);
            });
            return results.filter(function (e, i) { return i < 100; });
        }
        return self.Addresses().filter(function (e, i) { return i < 100; });
    }).extend({throttle: 500});

    self.attachAddressSubscribers = function(address) {
        address.SalutationId.subscribe(function(val) {
            address.Salutation($("#SalutationId option:selected").text());
        }, address);

        address.CountryId.subscribe(function(val) {
            address.Country($("#CountryIds option:selected").text());

            if (countryHasStateProvinceCode(val)) {
                address.IsStateProvinceCodeRequired(true);
            } else {
                address.IsStateProvinceCodeRequired(false);
            }

            $.ajax({
                type: "GET",
                url: ajaxUrls.area.ajax.country.IsEuCountry,
                data: { id: val }
            }).done(function (isEu) {
                address.ShowVat(isEu);
            }).fail(function () {
                alerts.error();
            });
        }, address);
    };
};

var AddressCommissionReceiverModel = function (pageModelHndl) {
    var that = this;

    // base data
    that.CommissionReceiverId = ko.observable();
    that.Name = ko.observable();

    // sub data
    that.CommissionReceiverTypes = ko.observableArray([]);

    // functions
    that.PopulateCommissionReceiverModel = function(commissionReceiverData) {
        that.CommissionReceiverId(commissionReceiverData.CommissionReceiverId);
        that.Name(commissionReceiverData.Name);
    };
};

var AddressSalutationModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.CountryId = ko.observable();
    that.CountryName = ko.observable();

    //functions
    that.PopulateSalutationModel = function (salutationData) {
        that.CountryId(salutationData.SalutationId);
        that.CountryName(salutationData.SalutationName);
    };
};

var AddressCountryModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.CountryId = ko.observable();
    that.CountryName = ko.observable();
    that.ISO = ko.observable();
    that.IsEU = ko.observable(false);
    that.DeliveryOptionIds = ko.observableArray([]);

    //functions
    that.PopulateCountryModel = function (countryData) {
        that.CountryId(countryData.CountryId);
        that.CountryName(countryData.Name);
        that.ISO(countryData.ISO);
        that.IsEU(countryData.IsEU);
        that.DeliveryOptionIds(countryData.DeliveryOptionIds);
    };
};

const TermsOfPaymentModel = function (pageModelHndl) {
    const that = this;

    that.TermsOfPaymentId = ko.observable();
    that.Name = ko.observable();

    that.PopulateTermsOfPaymentModel = function (data) {
        that.TermsOfPaymentId(data.TermsOfPaymentId);
        that.Name(data.Name);
    }
}